import { v4 as uuid } from "uuid";
import { z } from "zod";
export const packagePolicySchema = z.object({
    contractor_package_id: z.string(),
    created: z.date(),
    package_policy_id: z.string(),
    project_id: z.string(),
    project_policy_id: z.string()
});
export const createDefaultPackagePolicy = (projectId, contractorPackageId, projectPolicyId) => {
    return {
        contractor_package_id: contractorPackageId,
        created: new Date(),
        package_policy_id: uuid(),
        project_id: projectId,
        project_policy_id: projectPolicyId
    };
};
